module.exports = __webpack_public_path__ + "img/story018@2x.cab9715a.png";